import { render, staticRenderFns } from "./comandas.vue?vue&type=template&id=ca2024e6"
import script from "./comandas.vue?vue&type=script&lang=js"
export * from "./comandas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports